import styled from 'styled-components';
import React, { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';
import CriarConta from '../CriarConta.js';


function LoginCadastro({item,DadosAPI }) {

    

    //Navegacao lista de pordutos

    const navigate = useNavigate();

     


    return (
         <>
             <CriarConta/>
         </>
    );
}

export default LoginCadastro;
